import React from 'react'

import { HowToMakeSongChapters } from '../../../utils/blog-guides/howToMakeSongConstants'
import { GhostPost } from '../../../utils/types'
import HowToMakeSongGuide from '../../landing/HowToMakeSongSections/GuideSection/how-to-make-song-guide'
import styles from './GuideFooter.module.scss'

type Props = {
  post: GhostPost
}

const get4ClosestItems = (len: number, index: number) => {
  const arr = new Array(len).fill(0).map((_, ind) => ind)
  let result = []
  if (index < len / 2) {
    const min = Math.max(0, index - 2)
    result = arr.slice(min, min + 5)
  } else {
    const max = Math.min(len, index + 2)
    result = arr.slice(max - 5, max)
  }
  return result.filter((a) => a !== index)
}

const GuideFooter: React.FC<Props> = ({ post }) => {
  const { head_config } = post
  return (
    <div className={styles.relatedArticlesContainer}>
      <HowToMakeSongGuide
        chaptersIndexes={get4ClosestItems(HowToMakeSongChapters.length, (head_config?.chapterNum || 1) - 1)}
        chapterMode
        className={styles.chapters}
      />
    </div>
  )
}

export default GuideFooter
